import React, {useEffect} from 'react';
import {inject, observer} from 'mobx-react';
import {withTranslation} from 'react-i18next';
import {useParams, useNavigate} from 'react-router';
import {Button} from 'semantic-ui-react';
import TableSelect from '../../../../../../components/table-select';
import columnConfig from './user-identities.column-config';
import {UserIdentitiesTableButtons} from './sub-components/table-buttons';
import {UserIdentitiesModals} from './sub-components/modals';

let UserIdentities = (props) => {
    const {
        t, userStore, userIdentitiesUIStore
    } = props;

    const params = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        userStore.retrieveUser(params.userId);
        return () => {
            userStore.reset();
            userIdentitiesUIStore.reset();
        };
    }, [userStore, userIdentitiesUIStore, params]);

    useEffect(() => {
        if (userStore.user && userStore.user.authenticationType === 'AUTH0') {
            navigate(`/accounts/${params.accountId}/users/${params.userId}`, {replace: true});
        }
    }, [userStore.user, navigate, params.accountId, params.userId]);

    function handleRowSelection(selectedRow) {
        userIdentitiesUIStore.setSelectedIdentity(selectedRow);
    }

    if (userStore.user && userStore.user.authenticationType === 'AUTH0') {
        return null;
    }

    return (
        <div className="content sticky-scroll">
            <UserIdentitiesModals/>

            <div className="section__full--width--padding">
                <h2 className="mt-4">{t('user:user.identities')}</h2>
                <div className="button-box my-2">
                    <Button className="button__primary"
                            disabled={userStore.isLoading || userStore.isExternallyManged()}
                            onClick={userIdentitiesUIStore.openAddIdentityModal}>
                        {t('user:user.add.identity')}
                    </Button>
                </div>
            </div>

            <TableSelect
                multiSelect={false}
                columnConfig={columnConfig}
                rowData={userStore.user && userStore.user.identities ? userStore.user.identities : []}
                loading={userStore.isLoading}
                handleRowsSelection={handleRowSelection}
                rowId="value"
                tableButtons={<UserIdentitiesTableButtons/>}
                isSticky={true}
                stickyTopOffset={55}
                stickyTopBarOffset={0}
                dataName={t('user:user.identities')}
                defaultColumnSorted="identityType"
            />
        </div>
    );
};

export default inject(
    'userStore',
    'userIdentitiesUIStore'
)(withTranslation(
    'user'
)(observer(UserIdentities)));
